import _get from 'lodash/get';

const localState = {
  permissions: [],
  screenPermissions: {},
  routePermissionMap: {
    invoice_search_screen: {
      queryPermission: 'menuinvoicequery',
      editPermission: 'invoiceedit',
      deletePermission: 'deleteinvoice',
    },
    invoice_new_screen: {
      queryPermission: 'menuinvoicequery',
      editPermission: 'invoiceedit',
      deletePermission: 'deleteinvoice',
    },
    invoice_edit_screen: {
      queryPermission: 'menuinvoicequery',
      editPermission: 'invoiceedit',
      deletePermission: 'deleteinvoice',
    },
    job_edit_screen: {
      editPermission: 'jobedit',
    },
    report_edit_screen: {
      editPermission: 'reportedit',
    },
    order_search_screen: {
      queryPermission: 'orderquery,orderqueryown',
    },
  },
};

const localGetters = {
  permissions: state => state.permissions,
  screenPermissions: state => state.screenPermissions,
  hasRoutePermissions: state => routeName => {
    return _get(state.routePermissionMap, routeName);
  },
  isPermPresent: state => allowedPerms => {
    const searchforany = allowedPerms.split(',');
    for (const perm of state.permissions) {
      for (const searchingfor of searchforany) {
        if (perm.permissionname === searchingfor) return true;
      }
    }
    return false;
  },
  allPermsPresent: (state, getters) => allowedPerms => {
    const perms = allowedPerms.split(',');
    return !perms.some(perm => {
      return !getters.isPermPresent(perm);
    });
  },
};

const localActions = {
  initializePermissions({ commit }, permissions) {
    commit('set_initial_permissions', permissions);
  },

  setScreenPermissions({ commit }, payload) {
    commit('set_screen_permissions', payload);
  },
};

const localMutations = {
  set_initial_permissions(state, permissions) {
    state.permissions = permissions;
  },

  set_screen_permissions(state, payload) {
    state.screenPermissions = payload;
  },
};

export default {
  namespaced: true,
  state: localState,
  getters: localGetters,
  actions: localActions,
  mutations: localMutations,
};
